/**
 * Single source of truth for the "new customer billing model" copy.
 *
 * Tweak the wording here once and it propagates to the signup/onboarding
 * (CompleteProfile), the add-org flow (AddAccountModal, AddOrgTypeModal),
 * and the zero-org empty state on the Organizations page.
 *
 * Keep the wording aligned with the backend behavior:
 *   - data/Stripe_product_prices.php: ORG_SUBSCRIPTION_TRIAL_DAYS
 *   - application/libraries/Stripe_lib.php: trial_period_days = N
 */

/** Primary billing notice (compact banner, profile, organizations, modals). */
export const NEW_CUSTOMER_BILLING_COMPACT_LINE =
  "First 30 days are free — we save your card and only charge it 30 days later, then monthly on autopay. Cancel any time before the 30-day trial ends to avoid being charged.";

export const NEW_CUSTOMER_BILLING_TITLE =
  "Backup subscriptions — your first 30 days are free";

export const NEW_CUSTOMER_BILLING_BULLETS = [
  "Each organization you connect needs an active backup subscription before automated backups can run.",
  NEW_CUSTOMER_BILLING_COMPACT_LINE,
  "Already have a card on file? Subscribing reuses that card automatically.",
];

export const PROFILE_BEFORE_SUBSCRIBE_TITLE = "Before you subscribe";

export const PROFILE_TAX_ADDRESS_REQUIRED_NOTE =
  "Kindly update your company tax number and company address. We need these details for invoicing.";

export const BACKUP_SUBSCRIPTION_TOOLTIP =
  `Each connected organization needs an active backup subscription. ${NEW_CUSTOMER_BILLING_COMPACT_LINE}`;
